function removeTypenames<T>(item: T): T {
	if (typeof item !== "object" || !item) {
		return item as unknown as T;
	}
	if (Array.isArray(item)) {
		return item.map((i) => removeTypenames(i)) as unknown as T;
	}

	return Object.fromEntries(
		Object.entries(item)
			.filter(([name]) => name !== "__typename")
			.map(([name, value]) => [name, removeTypenames(value)]),
	) as unknown as T;
}

export default removeTypenames;
